const tokenStoragePath = 'authToken';
const templatesListSortingPath = 'templates.list.sorting';

type AccessorBuilderReturn = [() => string | null, (value: string) => void, () => void];
type ObjectAccessorBuilderReturn = [
  () => Record<string, unknown> | null,
  (value: Record<string, unknown>) => void,
  () => void,
];

const buildAccessor = (path: string): AccessorBuilderReturn => {
  return [
    () => localStorage.getItem(path),
    (value: string) => localStorage.setItem(path, value),
    () => localStorage.removeItem(path),
  ];
};

const buildObjectAccessor = (path: string): ObjectAccessorBuilderReturn => {
  return [
    () => {
      const serialized = localStorage.getItem(path);
      return serialized ? (JSON.parse(serialized) as Record<string, unknown>) : null;
    },
    (value: Record<string, unknown>) => localStorage.setItem(path, JSON.stringify(value)),
    () => localStorage.removeItem(path),
  ];
};

export const [getAuthToken, setAuthToken, removeAuthToken] = buildAccessor(tokenStoragePath);

export const [getTemplatesSorting, setTemplatesSorting, removeTemplatesSorting] =
  buildObjectAccessor(templatesListSortingPath);
